import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function BerkeleyAirMonitoring() {
  return (
    <div className="art-page">
      <SEO
        title="Monitoring for Uganda Energy Efficient Stoves (Berkeley Air Monitoring Group)"
        description="Over nearly a decade, CIRCODU served as principal field and laboratory monitoring partner for Berkeley Air's Uganda Energy Efficient Stoves programme, conducting laboratory, field, and factory monitoring."
        keywords="Berkeley Air, energy efficient stoves, laboratory testing, field monitoring, factory audits, Uganda, cookstove monitoring, air quality monitoring, stove usage monitoring, carbon verification, CIRCODU, Berkeley Air monitoring Uganda, energy efficient stoves Uganda, laboratory testing Uganda, field monitoring Uganda, factory audits Uganda, cookstove monitoring Uganda, air quality monitoring Uganda, stove usage monitoring Uganda, carbon verification Uganda"
        url="/Monitoring-for-Uganda-Energy-Efficient-Stoves-Berkeley-Air-Monitoring-Group"
        datePublished="2015-04-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Monitoring for Uganda Energy Efficient Stoves — Berkeley Air
              Monitoring Group
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              April 01, 2015
            </div>
            <h1 className="art-title">
              Monitoring for Uganda Energy Efficient Stoves (Berkeley Air
              Monitoring Group)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Over nearly a decade, CIRCODU served as the principal field and
                laboratory monitoring partner for{" "}
                <strong>
                  Berkeley Air Monitoring Group's Uganda Energy Efficient Stoves
                  programme
                </strong>{" "}
                — one of the longest-running and most comprehensive cookstove
                monitoring engagements in Uganda's history. Berkeley Air
                Monitoring Group is a US-based organisation with global
                expertise in air quality monitoring and energy access research,
                and its partnership with CIRCODU combined international
                methodological rigour with deep local knowledge of Uganda's
                household cooking landscape.
              </p>
              <p>
                This partnership established CIRCODU as the country's foremost
                independent monitoring institution for clean cooking
                technologies, and laid the foundation for its subsequent
                regional leadership role.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                The scope of CIRCODU's work was broad and methodologically
                rigorous, spanning three operational levels:
              </p>
              <ol>
                <li>
                  <strong>Laboratory:</strong> CIRCODU performed Water Boiling
                  Tests and thermal shock tests on a diverse range of stove
                  models and fuel types distributed through the programme,
                  providing standardised efficiency data that fed directly into
                  carbon verification reporting.
                </li>
                <li>
                  <strong>Field:</strong> CIRCODU conducted Kitchen Performance
                  Tests, kitchen surveys, and usage surveys in both project and
                  control households and institutions, carried out on a
                  quarterly, annual, and biannual schedule across the life of
                  the programme. This sustained monitoring cadence enabled
                  tracking of stove adoption trends, usage continuity, and fuel
                  consumption patterns over time, generating a rich longitudinal
                  dataset on household cooking behaviour in Uganda.
                </li>
                <li>
                  <strong>Factory:</strong> Monthly and quarterly spot-check
                  visits allowed CIRCODU to verify the accuracy of manufacturer
                  sales and inventory records, ensuring that stove distribution
                  figures were credibly supported by supply-side evidence.
                </li>
              </ol>
              <h2 className="art-subheading">Legacy</h2>
              <p>
                The nearly ten-year duration of this engagement made it one of
                the most sustained monitoring partnerships in the East African
                clean cooking sector. The methodological experience, field
                networks, and institutional knowledge developed through this
                programme became core assets of CIRCODU's organisational
                capacity, directly informing the quality of its monitoring work
                across dozens of subsequent assignments.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's monitoring and evaluation
                services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
